// extracted by mini-css-extract-plugin
export default {"keyWalletButton":"Header_keyWalletButton__c5xbS","chainWrapper":"Header_chainWrapper__oD5Cf","BSCButton":"Header_BSCButton__lm2YY"};